<template>
  <nav>
    <ul>
      <li class="name">
        <p @click="goToRoute" id="/" role="navigation">minhamola</p>
      </li>
      <li class="desktop-navigation-items">
          <ul>
            <li @click="goToRoute" tabindex="0" id="/dicas-de-gestao" role="button">
              Dicas de poupança
            </li>
            <li @click="goToRoute" tabindex="0" id="/sobre-a-aplicacao" role="button">
              Sobre minhamola
            </li>
            <li @click="goToRoute" tabindex="0" id="/perguntas-frequentes" role="button">
              Perguntas frequentes
            </li>
            <li @click="goToRoute" tabindex="0" id="/contacte-me" role="button">Contacte-me</li>
            <li v-if="isLoggedIn" tabindex="0">
              <AppButton @click.native="logOut" class="signout-button" text="sair"/>
            </li>
        </ul>
      </li>
      <li class="login-button">
        <AppButton @click.native="goToRoute" id="entrar" text="entrar" v-if="isAtHome" />
      </li>
      <li key="1" v-if="!getMenuStatus" @click="changeMenuStatus(null)">
        <AppIcon iconName="appMenuClosed" />
      </li>
      <li key="2" v-else @click="changeMenuStatus(null)">
        <AppIcon iconName="appMenuOpen" />
      </li>
    </ul>
    <TheMenu class="menu" v-show="getMenuStatus" />
  </nav>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import AppIcon from "@/components/AppIcon.vue";
import AppButton from "@/components/AppButton.vue";
import TheMenu from "@/components/TheMenu.vue";

export default {
  name: "AppNavbar",
  components: {
    AppIcon,
    AppButton,
    TheMenu
  },
  data() {
    return {
      signInBtnOptions: {
        text: "Entrar",
        type: "outline"
      }
    };
  },
  methods: {
    ...mapActions(["changeMenuStatus"]),
    goToRoute(e) {
      const nextRoute = e.srcElement.id;
      const currentRoute = this.$route.path;

      if (currentRoute !== nextRoute) this.$router.push(nextRoute);
      if (this.getMenuStatus === true) this.changeMenuStatus(false);
    }
  },
  computed: {
    ...mapGetters(["getMenuStatus", "isLoggedIn"]),
    isAtHome() {
      const currentRoutePath = this.$route.path;

      if (currentRoutePath === "/") return true;
      return false;
    }
  }
};
</script>

<style scoped>
nav {
  position: sticky;
  display: flex;
  flex-grow: 1;
  height: 4.5rem;
  top: 0;
  z-index: 1;
  background-color: var(--color-primary);
  padding: 1.2rem 1rem;
}

nav ul {
  display: flex;
  flex-grow: 1;
  align-items: center;
}

nav ul svg {
  cursor: pointer;
}

.desktop-navigation-items {
  display: none;
}

.name p {
  width: fit-content;
  color: var(--color-quaternary);
  font-weight: 600;
  cursor: pointer;
}

.login-button {
  margin-left: auto;
  margin-right: 0.8rem;
}

.login-button button {
  padding: 0.3rem 1rem;
  background-color: var(--primary-color);
  color: var(--color-quaternary);
  border: 2px solid var(--color-quaternary);
}

.menu {
  position: absolute;
  right: 0;
  top: 4.5rem;
  justify-items: center;
  align-items: center;
}
</style>
